const topPadding = 20

export class ToolsClass {
  static getCookie (name) {
    let value = '; ' + document.cookie
    let parts = value.split('; ' + name + '=')
    if (parts.length === 2) return parts.pop().split(';').shift()
  }
  static setCookie (name, value, expireDays, onlyDeveloper) {
    let expireTime = new Date()
    expireTime.setTime(expireTime.getTime() + (expireDays * 24 * 60 * 60 * 1000))
    value = value || true
    value = typeof value !== 'string' ? JSON.stringify(value) : value
    document.cookie = name + '=' + value + '; expires=' + expireTime.toGMTString() + ';domain=' + (onlyDeveloper ? window.location.hostname : '.autopay.pl') + ';path=/;'
  }
  static removeCookie (name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.autopay.pl;path=/;'
  }
  static removePolishSignsFromText (text) {
    if (typeof text !== 'string') {
      return text
    }
    return text.replace(/ą/g, 'a').replace(/Ą/g, 'A')
      .replace(/ć/g, 'c').replace(/Ć/g, 'C')
      .replace(/ę/g, 'e').replace(/Ę/g, 'E')
      .replace(/ł/g, 'l').replace(/Ł/g, 'L')
      .replace(/ń/g, 'n').replace(/Ń/g, 'N')
      .replace(/ó/g, 'o').replace(/Ó/g, 'O')
      .replace(/ś/g, 's').replace(/Ś/g, 'S')
      .replace(/[żź]/g, 'z').replace(/[ŻŹ]/g, 'Z')
  }

  static scrollTop (delay) {
    delay = delay || 250
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    }, delay)
  }

  static scrollToElement (element) {
    if (!element || !(element instanceof HTMLElement)) {
      return
    }
    const elementTopPosition = element.getBoundingClientRect()['y'] || element.getBoundingClientRect()['top']
    const scrollToPosition = window.scrollY + elementTopPosition - topPadding
    window.scrollTo({ left: 0, top: scrollToPosition, behavior: 'smooth' })
  }

  static moveToTop () {
    window.scrollTo({ left: 0, top: 190 })
  }

  static moveToElement (element) {
    if (!element || !(element instanceof HTMLElement)) {
      return
    }
    setTimeout(() => {
      const elementTopPosition = element.getBoundingClientRect()['y'] || element.getBoundingClientRect()['top']
      const scrollToPosition = window.scrollY + elementTopPosition - topPadding
      window.scrollTo({ left: 0, top: scrollToPosition })
    }, 500)
  }

  static each (value, callback) {
    if (!value || !(value instanceof Object) || typeof callback !== 'function') {
      return
    }
    for (const key in value) {
      callback(value[key], key)
    }
  }

  static deepCopy (value) {
    return ToolsClass.copyValue(value, null, null)
  }

  static deepExtend (dest, value) {
    if (!(dest instanceof Object) || (dest instanceof Date)) {
      return console.error('Can\'t extend given value', dest)
    }
    if (!(value instanceof Object) || (value instanceof Date)) {
      return console.error('Can\'t extend from value', value)
    }
    ToolsClass.each(value, (keyValue, key) => {
      if (dest instanceof Array) {
        dest.push(ToolsClass.copyValue(keyValue, null, null))
      } else {
        ToolsClass.copyValue(keyValue, dest, key)
      }
    })
    return dest
  }

  static copyValue (value, dest, key) {
    if (value instanceof Array) {
      const newArr = []
      value.forEach((arrValue, index) => {
        this.copyValue(arrValue, newArr, index)
      })
      addResult(newArr)
    } else if (value instanceof Date) {
      addResult(new Date(value))
    } else if (value instanceof Object) {
      const newObj = {}
      ToolsClass.each(value, (keyValue, key2) => {
        this.copyValue(keyValue, newObj, key2)
      })
      addResult(newObj)
    } else if (typeof value === 'symbol') {
      addResult(Symbol(value.toString().match(/^Symbol\((.*)\)$/)[1]))
    } else {
      addResult(value)
    }
    return dest

    function addResult (result) {
      if (!dest) {
        dest = result
      } else {
        dest[key] = result
      }
    }
  }
}
